<script setup lang="ts">
import { Check } from 'lucide-vue-next'

// Online application answered by partner banks; banks show a status only, never a rate
const props = withDefaults(defineProps<{ variant?: 'credits' | 'mortgage' }>(), {
  variant: 'credits'
})

const { t } = useI18n()

const application = computed(() =>
  props.variant === 'mortgage'
    ? { title: t('widget.hero_banner.illustration.mortgage.application'), amount: '3 500 000', term: t('widget.hero_banner.illustration.mortgage.term') }
    : { title: t('widget.hero_banner.illustration.credits.application'), amount: '500 000', term: t('widget.hero_banner.illustration.credits.term') }
)

const answers = [
  { bank: 'Бакай Банк', logo: '/images/banks/bakai.png', done: true },
  { bank: 'MBANK', logo: '/images/banks/mbank.png', done: true },
  { bank: 'Демир Банк', logo: '/images/banks/demir-bank.png', done: false }
]
</script>

<template>
  <div class="relative w-[21rem] select-none" aria-hidden="true">
    <div class="absolute inset-x-6 -top-2 h-full -rotate-3 rounded-2xl bg-blue-100" />

    <div class="HeroIllustrationCard">
      <div class="flex items-start justify-between gap-3">
        <div>
          <div class="text-sm text-gray-500">{{ application.title }}</div>
          <div class="font-serif text-2xl font-bold">
            {{ application.amount }}
            <span class="font-sans text-sm font-normal text-gray-500">{{ t('widget.hero_banner.illustration.som') }} {{ application.term }}</span>
          </div>
        </div>
        <span class="shrink-0 rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
          {{ t('widget.hero_banner.illustration.credits.sent') }}
        </span>
      </div>

      <ul class="mt-3 space-y-1.5">
        <li
          v-for="answer in answers"
          :key="answer.bank"
          class="flex items-center gap-3 rounded-xl px-3 py-1.5"
          :class="answer.done ? 'bg-blue-50' : 'bg-gray-50'"
        >
          <NuxtImg
            v-if="answer.logo"
            :src="answer.logo"
            alt=""
            width="32"
            height="32"
            class="size-8 rounded-lg bg-white object-contain p-0.5 ring-1 ring-gray-100"
          />
          <span
            v-else
            class="grid size-8 place-items-center rounded-lg bg-white text-[0.625rem] font-bold text-blue-700 ring-1 ring-gray-100"
          >
            {{ answer.bank }}
          </span>
          <span class="flex-1 text-sm font-semibold">{{ answer.bank }}</span>
          <span v-if="answer.done" class="flex items-center gap-1 text-sm font-semibold text-green-700">
            <Check class="size-4" />
            {{ t('widget.hero_banner.illustration.credits.approved') }}
          </span>
          <span v-else class="flex items-center gap-1.5 text-sm text-gray-500">
            <span class="relative flex size-2">
              <span class="absolute inline-flex size-full animate-ping rounded-full bg-yellow-400 opacity-75 motion-reduce:hidden" />
              <span class="relative inline-flex size-2 rounded-full bg-yellow-400" />
            </span>
            {{ t('widget.hero_banner.illustration.credits.reviewing') }}
          </span>
        </li>
      </ul>
    </div>

    <div class="HeroIllustrationBadge -bottom-4 -left-8">
      {{ t('widget.hero_banner.illustration.credits.answer') }}
    </div>
  </div>
</template>
